// Dictado con el reconocimiento de voz del navegador (Web Speech API): sin
// backend ni costo. Chrome y Edge lo tienen; Firefox no, y ahí no se muestra
// el micrófono.
const Recognition =
  typeof window !== "undefined" &&
  (window.SpeechRecognition || window.webkitSpeechRecognition);

// Chrome transcribe en sus servidores: tras stop() el texto final puede tardar
// (más con mala conexión) y llega antes de onend. Si onend no llega en este
// tiempo se corta, para no dejar el envío bloqueado.
const FINISH_TIMEOUT_MS = 8000;

export const isSpeechSupported = () => Boolean(Recognition);

/**
 * Empieza a escuchar. onText recibe todo lo dictado hasta ahora cada vez que
 * cambia (lo último puede ser provisional y cambiar). onEnd llega cuando ya no
 * va a llegar más texto.
 * Devuelve { stop, abort }: stop termina y espera el texto final; abort corta
 * y descarta lo que falte.
 */
export function startDictation({ lang, onText, onEnd, onError }) {
  const recognition = new Recognition();
  recognition.lang = lang;
  recognition.interimResults = true;
  recognition.continuous = true;
  let finishTimer = null;

  recognition.onresult = event => {
    onText(
      Array.from(event.results)
        .map(result => result[0].transcript)
        .join("")
    );
  };
  recognition.onerror = event => onError && onError(event.error);
  recognition.onend = () => {
    clearTimeout(finishTimer);
    onEnd && onEnd();
  };
  recognition.start();

  return {
    stop() {
      recognition.stop();
      finishTimer = setTimeout(() => recognition.abort(), FINISH_TIMEOUT_MS);
    },
    abort() {
      recognition.abort();
    }
  };
}
